'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdLowPriority = function MdLowPriority(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm3.4 19.1c0-5.9 4.8-10.7 10.7-10.7h5.9v3.2h-5.9c-4.1 0-7.5 3.4-7.5 7.5s3.4 7.5 7.5 7.5h0.9v-3.2l5 5-5 5v-3.4h-0.9c-5.9 0-10.7-4.9-10.7-10.9z m20 7.5h13.2v3.4h-13.2v-3.4z m0-9.1h13.2v3.4h-13.2v-3.4z m0-9.1h13.2v3.2h-13.2v-3.2z' })
        )
    );
};

exports.default = MdLowPriority;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/low-priority.js
// module id = 3058
// module chunks = 0